module.exports = __webpack_public_path__ + "static/banner-homepage-861ffec84d1398c2e68a03df67616804.jpg";